'use strict';

import { GenericTableData } from 'Lib/data';

// Biobank Module Event Bus.
let BiobankData = GenericTableData.getTableDataBus('BIOBANK', 'biobanks');

BiobankData.getBiobank = (id) => {
  return BiobankData.getRecord(id, {
    _include: '$biobank_notes.users,',
  });
};

BiobankData.getBiobankList = (opts) => {
  let where = {
    ...(opts?.where && { ...opts.where }),
  };

  let options = {
    ...opts,
    where: where,
  };
  return BiobankData.getRecordList(options);
};

let exportCols = [
  { key: 'id', header: 'ID' },
  { key: 'institution', header: 'Institution' },
  { key: 'indication', header: 'Indication' },
  { key: 'in_scope', header: 'In Scope' },
  { key: 'in_scope_notes', header: '' },
  { key: 'num_individuals', header: 'N (Individuals)' },
  { key: 'num_individuals_notes', header: '' },
  { key: 'molecular_profiling', header: 'Molecular Profiling' },
  { key: 'molecular_profiling_notes', header: '' },
  { key: 'biospecimens', header: 'Biospecimens' },
  { key: 'link', header: 'Link' },
  { key: 'investigator', header: 'Investigator' },
  { key: 'comments', header: 'Comments' },
];

BiobankData.exportList = (opts) => {
  BiobankData.exportRecordList({ ...opts, columns: exportCols });
};

BiobankData.createBiobank = (biobankObject) => {
  return BiobankData.createRecord({
    ...biobankObject,
    // user_id: AppData.userID(),
  });
};

BiobankData.getCreateBiobankFunction = (user_id) => {
  return (biobankObject) => {
    return BiobankData.createRecord({
      ...biobankObject,
      user_id,
    });
  };
};

BiobankData.deleteBiobank = (biobankId) => {
  return BiobankData.deleteRecords(biobankId);
};

export default BiobankData;
